import { Set } from '~commonInfra/utils/Set';

import { Formatters,Messages } from '../../../../codegen/Localize';
import { openReactConfirmationDialog } from '../../../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { SiteUsers } from '../../../services/resources/SiteUsers';
import { ISiteUserInfo } from '../../../users/models/ISiteUserInfo';
import { IGroupInfo } from '../../models/IGroupInfo';
import { GroupMembershipUpdateActionNotification } from '../notifications/GroupMembershipUpdateActionNotification';

type RemoveUsersFromGroupActionParams = {
  userKeys: string[];
  groupId: string;
}

function showRemoveUsersFromGroupDialog(
  groupUsers: Set<ISiteUserInfo>,
  group: IGroupInfo): Promise<any> {

  const dialogBody = Messages.confirmRemoveUsersFromGroup({
    USER_NAME: L10n.elideIfLong(groupUsers.first().displayName),
    USER_COUNT: groupUsers.size(),
    USER_COUNT_LOC: Formatters.formatCount(groupUsers.size()),
    GROUP_NAME: L10n.elideIfLong(group.name)
  });

  const dialogInstance = openReactConfirmationDialog<RemoveUsersFromGroupActionParams, IResult>({
    title: Messages.remove(),
    message: dialogBody,
    actionName: Messages.confirmRemoveButton({
      ITEM_COUNT: groupUsers.size(),
      ITEM_COUNT_LOC: Formatters.formatCount(groupUsers.size())
    }),
    isActionDelete: true,
    action: ({ userKeys, groupId }) => SiteUsers.instance.removeFromGroups(userKeys, [ groupId ]),
    paramsForAction: { userKeys: groupUsers.keys(), groupId: group.id },
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    GroupMembershipUpdateActionNotification.notify(
      result,
      groupUsers,
      0,
      null,
      1,
      group.name);
  });

  return dialogInstance.result;
}

export const RemoveUsersFromGroupAction = {
  showRemoveUsersFromGroupDialog
};
